<div class="full-height-message text-center" *ngIf="chartStatus === 0 && !chartData">
  <i class="fas fa-circle-notch fa-spin fa-2x text-primary"></i>
</div>

<div class="full-height-message text-center" *ngIf="chartStatus === 2 && appService">
  <h5 class="text-muted mt-2">{{appService.CoreCommonLiterals.NoData}}</h5>
</div>

<div class="chart-container" [style.height.px]="height" [ngClass]="{'d-none': chartStatus === 0 || chartStatus === 2}">
  <div class="chart-wrapper">
    <canvas #chartCanvas></canvas>
  </div>
</div> 